import { Routesteps } from './types';

export const RoutesStepsWithoutCredit: Routesteps[] = [
  {
    label: 'Dados dos representantes',
    path: '/representantes/cadastrar',
  },
  {
    label: 'Envio de documentos',
    path: '/representantes/envio-de-documentos-e-selfie',
  },
  {
    label: 'Análise de documentos',
    path: '/representantes/analise-de-documentos',
  },
  { label: 'Conta criada com sucesso', path: '/representantes/conta-criada' },
];

export const RoutesStepsWithCredit: Routesteps[] = [
  ...RoutesStepsWithoutCredit,
  { label: 'Formalização do crédito', path: '' },
  { label: 'Envio de recebíveis (CTes)', path: '' },
  { label: 'Contrato de concessão', path: '' },
  { label: 'Liberação do crédito', path: '' },
];
